import Vue from "Vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class InputText extends Vue {
	@Prop({ default: "" })
	public label;

	@Prop()
	private vmodel;

	@Prop({ default: 50 })
	private length;

	@Prop({ default: false })
	private disabled;

	@Prop({ default: false })
	private required;

	@Prop({ default: true })
	private show;

	@Prop({ default: false })
	private error;

	@Prop({ default: false })
	private uppercase;

	@Prop({ default: false })
	private right;

	@Prop({ default: false })
	private textarea;

	@Prop({ default: 5 })
	private rows;


	public value;

	public constructor() {
		super();
		this.value = "";
	}

	@Watch("vmodel", { immediate: true })
	private setValue(): void {
		this.value = this.vmodel;
	}

	private isTextSelected(e): boolean {
		return e.target.selectionStart == 0 && e.target.selectionEnd == e.target.value.length;
	}

	public keydown(e): void {
		const testString = (this.isTextSelected(e))
			? e.key
			: e.target.value.substring(0, e.target.selectionStart) + e.key + e.target.value.substring(e.target.selectionStart);
		if (e.key != "Backspace" &&
			e.key != "ArrowLeft" &&
			e.key != "ArrowRight" &&
			e.key != "ArrowUp" &&
			e.key != "ArrowDown" &&
			e.key != "Comma" &&
			e.key != "Tab") {
			if (testString.length > this.length) {
				e.preventDefault();
			}
		}
	}

	public focus(e): void {
		e.target.select();
	}

	public input(e): void {
		if (this.uppercase) {
			e.target.value = e.target.value.toUpperCase();
		}
	}

	public blur(e): void {
		this.$emit("update:vmodel", e.target.value);
	}

	public paste(e): void {
		e.preventDefault();
	}
}



// WEBPACK FOOTER //
// ./src/shared/components/InputText/InputText.ts